import { parseHandicap } from "./parseHandicap";

export function getBetDesc(bet) {
	if ((bet.calculateHandicapDescription) && !bet.isCompact) {
		return parseHandicap(bet.desc, bet.handicap, bet.tipoHandicap, bet.draws, bet.dia);
	} else {
        return bet.desc;
	}
}
